import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';

class Zeldiablo extends Component {
  render() {
    return (
    <ProjectPage title="Zeldiablo">

      <div className='project-page-part'>

        <Table className="centered" data={{
          Status : "Finished",
          Type : "School project",
          Language : "Java",
          Duration : "1 week",
          Team : "Group of 4",
          Date : "2021"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>

        <p className='basic-text'>
          During my DUT I had to make a simple game in Java.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>

        <p className='basic-text'>
          Zeldiablo is a small top-down game where you have to escape the 3 levels of the labyrinth by taking the amulet that unlock the stairs but be aware of the zombies along the path.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>My contribution :</h3>

        <ul className='basic-text'>
          <li>Art</li>
          <li>Movements</li>
          <li>Levels</li>
        </ul>

      </div>

      <div className='project-page-part'>

        <h3>Gameplay :</h3>

        <iframe className='project-video' title='Thrown In The Dungeon demo' allowFullScreen
        src="https://youtube.com/embed/MkxUuYSfcnY">
        </iframe>

      </div>

    </ProjectPage>
    );
  }
}

export default Zeldiablo;